import { Inject, Injector, Input, Directive } from '@angular/core';
import { KalgudiUsersPickerBase } from '@kalgudi/common';
import { KalgudiUserBasicSearchResults, KalgudiUtilityService } from '@kalgudi/core';
import { KalgudiNotification, KL_NOTIFICATION } from '@kalgudi/core/config';
import { StringAnyMap } from '@kalgudi/types';
import { EMPTY, Observable } from 'rxjs';

import { KalgudiProgramSearchService } from '../../../services/kalgudi-program-search.service';
import { DigitalAssistanceService } from '../services/digital-assistance.service';


/**
 *
 *
 * @author Pankaj Prakash
 */
@Directive()
export abstract class DigitalAssistanceFrequentMembersPicker extends KalgudiUsersPickerBase {

  @Input()
  pageId: string;

  protected api: DigitalAssistanceService;
  protected pageApi: KalgudiProgramSearchService;

  constructor(
    protected injector: Injector,
    @Inject(KL_NOTIFICATION) protected notification: KalgudiNotification,
    protected util: KalgudiUtilityService,
  ) {

    // Wake up (initialize) parent
    super(notification, util);

    this.defaultSearchKeyword = '';

    this.api = this.injector.get(DigitalAssistanceService);
    this.pageApi = this.injector.get(KalgudiProgramSearchService);
  }

  /**
   * Defines the Api call for my kalgudi connects. If the search keyword is provided then it calls
   * the Api to search my connects otherwise it loads the list of all my connects.
   *
   * It chooses the Api call based on the search keyword.
   */
  protected userApi(
    searchKeyword: string,
    offset: number,
    limit: number,
    extraParams?: StringAnyMap
  ): Observable<KalgudiUserBasicSearchResults> {

    let obs: any = EMPTY;

    if (this.pageId) {

      obs = searchKeyword && searchKeyword.length > 0
        ? this.pageApi.searchMembers(this.pageId, searchKeyword, offset, limit)
        : this.api.searchFrequentlyAssistedMembers(this.pageId);
    }

    return obs;
  }
}
